const state = {
    selectRow: null,
    viewTitle: '',

    last_search_form: {

    },

    audit_ill_id: null,
    audit_ill_ids: [],
    audit_img_id: null,
    audit_img_ids: [],
    currentMessage: null, //留言
    messages: [],
    audit_visit_id: null,
    audit_visit_ids: []
};

const mutations = {
    setRow(state, payload) {
        state.selectRow = payload.row;
        state.viewTitle = payload.title;
    },
    setLastSearchForm(state, payload) {
        state.last_search_form = payload
    },

    setIllRow(state,payload) {
        state.audit_ill_id = payload.row_id;
        state.audit_ill_ids = payload.all
    },
    setImgRow(state, payload) {
        state.audit_img_id = payload.row_id;
        state.audit_img_ids = payload.all
    },
    setVisitRow(state, payload) {
        state.audit_visit_id = payload.row_id;
        state.audit_visit_ids = payload.all
    },
    setMessageRow(state, payload) {
        state.currentMessage = payload.row;
        state.messages = payload.list
    },
};

const actions = {};

export default {
    namespaced: true,
    state,
    mutations,
    actions
}